export default __webpack_public_path__ + "static/media/searchBlack.9d89f111.svg";